import Input from '@blocks/Input'
import Select from '@blocks/Select'
import useOrganizations from '@hooks/models/useOrganizations'
import React from 'react'

export default function AwardForm({ model: award }: Modules.Resource.Form<Interfaces.Award.Includes<"organization">>) {
    const { organization, options } = useOrganizations(award?.organization_id)

    return (
        <>
            <Input id="name" name="name" label="Award" placeholder="FIAP Gold Medal" defaultValue={award?.name} required />
            <Select id="organization_id" name="organization_id" label="Organization" options={options} value={organization} isClearable={true} />
            <Input id="priority" name="priority" label="Priority" type="number" min={0} defaultValue={award?.priority} placeholder="1" />
        </>
    )
}